<template>
  <div class="text-center">
    <div class="upload-container" v-if="!imagePreview">
      <input
          accept="image/*"
          @change="handlePreview"
          type="file"
          name="..."
          aria-invalid="false"
      />
      <div class="upload-container__icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38 26C37.4696 26 36.9609 26.2107 36.5858 26.5858C36.2107 26.9609 36 27.4696 36 28V28.76L33.04 25.8C31.9948 24.7631 30.5823 24.1813 29.11 24.1813C27.6377 24.1813 26.2252 24.7631 25.18 25.8L23.78 27.2L18.82 22.24C17.7602 21.2312 16.3531 20.6686 14.89 20.6686C13.4269 20.6686 12.0198 21.2312 10.96 22.24L8 25.2V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H24C24.5304 12 25.0391 11.7893 25.4142 11.4142C25.7893 11.0392 26 10.5305 26 10C26 9.46959 25.7893 8.96088 25.4142 8.58581C25.0391 8.21074 24.5304 8.00002 24 8.00002H10C8.4087 8.00002 6.88258 8.63216 5.75736 9.75738C4.63214 10.8826 4 12.4087 4 14V38C4 39.5913 4.63214 41.1174 5.75736 42.2427C6.88258 43.3679 8.4087 44 10 44H34C35.5913 44 37.1174 43.3679 38.2426 42.2427C39.3679 41.1174 40 39.5913 40 38V28C40 27.4696 39.7893 26.9609 39.4142 26.5858C39.0391 26.2107 38.5304 26 38 26ZM10 40C9.46957 40 8.96086 39.7893 8.58579 39.4142C8.21071 39.0392 8 38.5305 8 38V30.86L13.8 25.06C14.0938 24.78 14.4841 24.6238 14.89 24.6238C15.2959 24.6238 15.6862 24.78 15.98 25.06L22.32 31.4L30.92 40H10ZM36 38C35.9971 38.3829 35.8709 38.7546 35.64 39.06L26.62 30L28.02 28.6C28.1634 28.4537 28.3345 28.3374 28.5234 28.258C28.7123 28.1787 28.9151 28.1378 29.12 28.1378C29.3249 28.1378 29.5277 28.1787 29.7166 28.258C29.9055 28.3374 30.0766 28.4537 30.22 28.6L36 34.42V38ZM45.42 8.58002L39.42 2.58002C39.2298 2.39794 39.0055 2.25521 38.76 2.16002C38.2731 1.95999 37.7269 1.95999 37.24 2.16002C36.9945 2.25521 36.7702 2.39794 36.58 2.58002L30.58 8.58002C30.3935 8.7665 30.2456 8.98788 30.1447 9.23152C30.0438 9.47517 29.9918 9.7363 29.9918 10C29.9918 10.5326 30.2034 11.0434 30.58 11.42C30.9566 11.7966 31.4674 12.0082 32 12.0082C32.5326 12.0082 33.0434 11.7966 33.42 11.42L36 8.82002V20C36 20.5305 36.2107 21.0392 36.5858 21.4142C36.9609 21.7893 37.4696 22 38 22C38.5304 22 39.0391 21.7893 39.4142 21.4142C39.7893 21.0392 40 20.5305 40 20V8.82002L42.58 11.42C42.7659 11.6075 42.9871 11.7563 43.2308 11.8578C43.4746 11.9593 43.736 12.0116 44 12.0116C44.264 12.0116 44.5254 11.9593 44.7692 11.8578C45.0129 11.7563 45.2341 11.6075 45.42 11.42C45.6075 11.2341 45.7562 11.0129 45.8578 10.7692C45.9593 10.5255 46.0116 10.264 46.0116 10C46.0116 9.736 45.9593 9.47459 45.8578 9.23087C45.7562 8.98715 45.6075 8.76595 45.42 8.58002Z" fill="#BDBDBD"/>
        </svg>
      </div>
      <div class="upload-container__text">
        Перетащите изображение сюда или нажмите, чтобы загрузить
      </div>
    </div>
    <div class="thumbnail" v-else>
      <cropper
          class="cropper"
          :src="imagePreview"
          ref="cropper"
          :stencil-props="{aspectRatio: 1}"
      ></cropper>
    </div>
  </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import $ from "jquery";
import {eventBus} from "@/main";
import ApiService from "../../services/api.service";
export default {
  name: 'image-upload',
  components: {
    Cropper
  },
  props: {
    type: {
      type: String,
      default: '',
      description: 'Image upload type (""|avatar)'
    },
    src: {
      type: String,
      default: '',
      description: 'Initial image to display'
    },
    selectText: {
      type: String,
      default: 'Выберите файлы'
    },
    changeText: {
      type: String,
      default: 'Загрузить заново'
    },
    removeText: {
      type: String,
      default: 'Отменить'
    }
  },
  data() {
    return {
      imagePreview: null,
      imageBlob: null,
      wasCropped: false
    };
  },
  methods: {
    blobToFile(theBlob, fileName){
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    handlePreview(event) {
      let file;
      file = event.target.files[0];
      setTimeout(() => {
        this.imagePreview = URL.createObjectURL(file)
        this.imageBlob = file
      }, 100)
      this.$emit('change', file);
    },
    removeFile() {
      this.imagePreview = null;
      this.$emit('change', null);
    }
  },
  mounted() {
    let self = this
    $('#avatar-upload').on('hide.bs.modal', function () {
      self.imagePreview = null
    })
    eventBus.$on('image:crop', () => {
      const result = this.$refs.cropper?.getResult();
      if (result) {
        const { canvas } = result;
        let self = this
        canvas.toBlob(function(blob) {
          self.imageBlob = blob
          self.imagePreview = URL.createObjectURL(blob)
        },'application/octet-stream');
      }
    })
    eventBus.$on('image:upload', async () => {
      let form = new FormData()
      form.append('context', 'default')
      form.append('binaryContent', this.imageBlob, 'file.png')
      ApiService
          .postFormData(`avatars`, form)
          .then(async (res) => {
            if(res.status === 201) {
              await ApiService.getMe()
              eventBus.$emit('user:upd')
              $('#avatar-upload').modal('hide')
            }
          })
    })
  }
};
</script>
<style lang="scss">
.upload-container {
  padding: 5.8rem 13.1rem;
  background: url("/pic/upload-bg.svg") center center no-repeat;
  background-size: contain;
  margin: 2.4rem 0 3.2rem;
  &__icon,
  &__text {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row;
    text-align: center;
  }
  &__text {
    font-size: 1.8rem;
    line-height: 2.4rem;
    color: #BDBDBD;
    margin-top: 2.4rem;
  }
}
.vue-advanced-cropper__background, .vue-advanced-cropper__foreground {
  background: #002E5E;
  width: calc(100% + 8rem)!important;
}
.thumbnail {
  min-height: 21rem;
}
input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.cropper {
  max-height: 450px;
  max-width: 100%;
}

</style>
